// extracted by mini-css-extract-plugin
export var chevronIcon = "_cw-2";
export var teamName = "_cw-1";
export var teamSwitcherButton = "_cw-0";